import LayoutSetInstance from 'components/ui/layout-set/instance/layout-set-instance';

import PageInstanceDetailsLayout from 'components/pages/professional/instance/shared/page-instance-details-layout';

import MenuCollapsedTopInstance from 'components/pages/professional/instance/shared/cmpt-menu-collapsed-top-instance';

import PageInstanceDetails from 'components/pages/professional/instance/instance-details/page-instance-details';
import PageInstanceLogo from 'components/pages/professional/instance/instance-logo/page-instance-logo';

import PageSettingsSubscription from 'components/pages/professional/instance/subscription/page-settings-subscription';

// import PageMyPreferencesProfilePicture from 'components/pages/professional/settings/my-preferences/profile-picture/page-my-preferences-profile-picture';

// import PageMyPreferencesChangeEmail from 'components/pages/professional/settings/my-preferences/change-email/page-my-preferences-change-email';
// import PageVerifyEmailManually from 'components/pages/professional/settings/my-preferences/change-email/page-verify-email-manually';

// import PageMyPreferencesChangePassword from 'components/pages/professional/settings/my-preferences/change-password/page-my-preferences-change-password';

// import PageMyPreferencesExternalLinks from 'components/pages/professional/settings/my-preferences/external-links/page-my-preferences-external-links';

// import PageMyPreferencesProfessionalBiography from 'components/pages/professional/settings/my-preferences/professional-biography/page-my-preferences-professional-biography';
// import PageProfessionalExperienceCRED from 'components/pages/professional/settings/my-preferences/professional-biography/page-professional-experience-cred';

import PageInstanceSourcesList from 'components/pages/professional/instance/sources/list/page-instance-sources-list';
import PageInstanceSourceDetails from 'components/pages/professional/instance/sources/details/page-instance-source-details';

import PageInstancePurchases from 'components/pages/professional/instance/subscriptions/purchases/page-instance-purchases';

import PageInstanceSubscriptionsList from 'components/pages/professional/instance/subscriptions/list/page-instance-subscriptions-list';
import PageInstanceSubscriptionDetails from 'components/pages/professional/instance/subscriptions/details/page-instance-subscription-details';

import PageInstanceSubscriptionInvoiceDetails from 'components/pages/professional/instance/subscriptions/details/page-instance-subscription-invoice-details';

import PageInstancePurchaseNew from 'components/pages/professional/instance/subscriptions/purchase-new/page-instance-purchase-new';
import PageInstancePurchaseNewSelectPlan from 'components/pages/professional/instance/subscriptions/purchase-new/step-1/page-instance-purchase-new-select-plan';
import PageInstancePurchaseNewReviewAndCheckout from 'components/pages/professional/instance/subscriptions/purchase-new/step-2/page-instance-purchase-new-review-and-checkout';

import PageInstancePurchaseNewThankYou from 'components/pages/professional/instance/subscriptions/purchase-new/step-3/page-instance-purchase-new-thank-you';

export default [
  {
    path: '/professional/settings/instance',
    component: LayoutSetInstance,
    name: 'settings-instance',
    redirect: { name: 'instance-profile-details' },
    meta: {
      auth: true,
    },
    children: [
      {
        path: 'profile',
        component: PageInstanceDetailsLayout,
        props: true,
        meta: {
          auth: true,
        },
        children: [
          {
            path: 'details',
            name: 'instance-profile-details',
            component: PageInstanceDetails,
            props: {
              meta: {
                title: 'label.instance_details',
                section: 'label.profile',
              },
            },
          },
          {
            path: 'logo',
            name: 'instance-profile-logo',
            component: PageInstanceLogo,
            props: {
              meta: {
                title: 'label.instance_logo',
                section: 'label.profile',
              },
            },
          },
        ],
      },
      {
        path: 'subscriptions',
        props: true,
        meta: { auth: true },
        components: {
          default: PageInstanceDetailsLayout,
          collapsedMenuTop: MenuCollapsedTopInstance,
        },
        children: [
          {
            path: 'purchases',
            name: 'instance-subscription-purchases',
            redirect: { name: 'instance-subscription-purchases-list' },
            component: PageInstancePurchases,
            props: {
              meta: {
                title: 'label.purchases',
                section: 'label.subscriptions',
              },
            },
            children: [
              {
                path: 'list',
                name: 'instance-subscription-purchases-list',
                component: PageInstanceSubscriptionsList,
                props: {
                  meta: {
                    title: 'label.purchases',
                    section: 'label.subscriptions',
                    navigation: {
                      details: 'instance-subscription-purchase-details',
                    },
                  },
                },
                children: [
                  {
                    path: 'new',
                    name: 'instance-subscription-purchase-new',
                    redirect: { name: 'instance-subscription-purchase-new-select-plan' },
                    component: PageInstancePurchaseNew,
                    props: {
                      meta: {
                        title: 'label.purchase_new_subscription',
                        section: 'label.subscriptions',
                        navigation: {
                          cancel: 'instance-subscription-purchases-list',
                        },
                      },
                    },
                    children: [
                      {
                        path: 'select-plan',
                        name: 'instance-subscription-purchase-new-select-plan',
                        component: PageInstancePurchaseNewSelectPlan,
                        props: {
                          meta: {
                            navigation: {
                              cancel: 'instance-subscription-purchases-list',
                              success: 'instance-subscription-purchase-new-review-and-checkout',
                            },
                          },
                        },
                      },
                      {
                        path: 'review-and-checkout',
                        name: 'instance-subscription-purchase-new-review-and-checkout',
                        component: PageInstancePurchaseNewReviewAndCheckout,
                        props: {
                          meta: {
                            navigation: {
                              cancel: 'instance-subscription-purchases-list',
                              back: 'instance-subscription-purchase-new-select-plan',
                              success: 'instance-subscription-purchase-new-thank-you',
                            },
                          },
                        },
                      },
                      {
                        path: 'thank-you',
                        name: 'instance-subscription-purchase-new-thank-you',
                        component: PageInstancePurchaseNewThankYou,
                        props: {
                          meta: {
                            navigation: {
                              success: 'instance-subscription-purchases',
                            },
                          },
                        },
                      },
                    ],
                  }, // end ~ new - instance-subscription-purchase-new
                  {
                    path: 'details/:id(\\d+)',
                    name: 'instance-subscription-purchase-details',
                    component: PageInstanceSubscriptionDetails,
                    props: route => ({
                      id: route.params.id,
                      meta: {
                        title: 'label.subscription_details',
                        section: 'label.subscriptions',
                        navigation: {
                          cancel: 'instance-subscription-purchases-list',
                          details: 'instance-subscription-invoice-details',
                        },
                      },
                    }),
                    children: [
                      {
                        path: 'invoice/:invoice_id(\\d+)',
                        name: 'instance-subscription-invoice-details',
                        component: PageInstanceSubscriptionInvoiceDetails,
                        props: route => ({
                          id: route.params.id,
                          invoiceID: route.params.invoice_id,
                          meta: {
                            title: 'label.invoice_details',
                            section: 'label.subscriptions',
                            navigation: {
                              back: 'instance-subscription-purchase-details',
                            },
                          },
                        }),
                      },
                    ],
                  }, // end ~ details
                ],
              },
            ],
          }, // end ~ purchases
        ],
      }, // end ~ subscriptions
      {
        path: 'settings',
        component: PageInstanceDetailsLayout,
        props: true,
        meta: {
          auth: true,
        },
        children: [
          {
            path: 'subscription',
            name: 'instance-settings-subscription',
            component: PageSettingsSubscription,
            props: {
              meta: {
                title: 'label.instance_subscription',
                section: 'label.settings',
              },
            },
          },
          {
            path: 'sources',
            name: 'instance-settings-sources',
            component: PageInstanceSourcesList,
            props: {
              meta: {
                title: 'label.sources',
                section: 'label.settings',
              },
            },
            children: [
              {
                path: 'details/:id',
                name: 'instance-settings-source-details',
                component: PageInstanceSourceDetails,
                props: route => ({
                  id: route.params.id,
                  meta: {
                    title: 'label.source_details',
                    section: 'label.sources',
                    navigation: {
                      cancel: 'instance-settings-sources',
                    },
                  },
                }),
              },
            ],
          }, // end ~ sources
        ],
      }, // end ~ settings
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/professional/settings/router-instance.js